import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'input-addon-group';
var Container = aggregatedClasses('div')(blockName);
var InputAddon = aggregatedClasses('span')(blockName, 'addon');

var AddonWrapper = /*#__PURE__*/function (_Component) {
  _inherits(AddonWrapper, _Component);

  var _super = _createSuper(AddonWrapper);

  function AddonWrapper() {
    var _this;

    _classCallCheck(this, AddonWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(AddonWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          leftAddon = _this$props.leftAddon,
          rightAddon = _this$props.rightAddon,
          inputComponent = _this$props.children,
          className = _this$props.className,
          containerProps = _this$props.containerProps;
      var childType = inputComponent && inputComponent.type && inputComponent.type.name ? inputComponent.type.name.toLowerCase() : 'default';
      return /*#__PURE__*/React.createElement(Container, _extends({
        className: "".concat(className, " ").concat(blockName, "--").concat(childType)
      }, containerProps), leftAddon && /*#__PURE__*/React.createElement(InputAddon, null, leftAddon), inputComponent, rightAddon && /*#__PURE__*/React.createElement(InputAddon, null, rightAddon));
    }
  }]);

  return AddonWrapper;
}(Component);

_defineProperty(AddonWrapper, "defaultProps", {});

export default AddonWrapper;
//# sourceMappingURL=AddonWrapper.js.map
